<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div class="MainBack" />
    <div class="listRect">
      <div v-for="item in list" :key="item.moneyAccountId" class="cardRect" :style="'background-color: '+GetColorMain()" @click="onEdit(item.moneyAccountId)">
        <div class="icon">
          <i class="iconfont iconstatepay" />
        </div>
        <div class="info">
          <span v-if="item.cashType==='BANK'">{{ item.bankName }}</span>
          <span v-if="item.cashType==='OFFLINE'">线下支付</span>
          <span v-if="item.cashType==='WECHAT_TRANSFER'">微信</span>
          <span v-if="item.cashType==='ALIPAY_TRANSFER'">支付宝</span>
          <div class="account">{{ item.cashName }}<br>{{ item.cashAccount }}</div>
        </div>
        <div class="backFont">
          <span v-if="item.cashType==='BANK'">{{ item.bankName }}</span>
          <span v-if="item.cashType==='OFFLINE'">线下</span>
          <span v-if="item.cashType==='WECHAT_TRANSFER'">微信</span>
          <span v-if="item.cashType==='ALIPAY_TRANSFER'">支付宝</span>
        </div>
      </div>
      <div class="addLine" @click="onAdd">
        <i class="iconfont iconadd" /> 添加交易账号
      </div>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button } from 'vant'
import TopBar from '@/components/TopBar'
import { ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    TopBar
  },
  data() {
    return {
      titleTop: '',
      title: '交易账号列表',
      backurl: '/pro/commission',
      list: []
    }
  },

  created() {
    this.titleTop = GetSysTitle()
    this.init()
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    onAdd() {
      this.$router.push('/pro/bankEdit/0')
    },
    onEdit(id) {
      this.$router.push('/pro/bankEdit/' + id)
    },
    init() {
      request({
        url: '/pro/GetMoneyAccountList',
        method: 'post'
      }).then(response => {
        if (!response.success) {
          return
        }
        this.list = response.data
      })
    }
  }
}
</script>
<style scoped>
.MainBack{
    height: 100vh;
    left: 0;
    top: 0;
    width: 100vw;
    background-color: #333333;
    position: absolute;
}
.listRect{
  position: absolute;
  z-index: 1;
  width: 100vw;
  left: 0;
  top: 3em;
  height: calc(100vh - 3em);
  overflow-y: scroll;
  overflow: hidden;
}
.cardRect{
  margin: 0.5em;
  padding: 1.8em 1em;
  height: 5em;
  background-color: #C65157;
  position: relative;
  border-radius: 0.4em;
  overflow: hidden;
}
.cardRect .icon{
  position: absolute;
  width: 1.8em;
  height: 1.8em;
  color: #fff;
  background-color: rgba(255,255,255,0.5);
  border-radius: 1.8em;
  text-align: center;
  line-height: 1.8em;
  z-index: 2;
}
.cardRect .info{
  color: #fff;
  position: absolute;
  left: 3.5em;
  right: 1em;
  top: 1.8em;
  bottom: 1em;
  z-index: 2;
}
.cardRect .backFont{
  position: absolute;
  z-index: 1;
  left: 2.3em;
  top: 0.3em;
  width: 100em;
  font-weight: 700;
  font-size: 6em;
  color: #fff;
  filter:alpha(Opacity=15);
  -moz-opacity:0.15;
  opacity: 0.15;
}
.cardRect .info .account{
  font-size: 1.1em;
  line-height: 1.7em;
  margin-top: 0.8em;
}
.addLine{
  color: #999;
  margin: 1em 0 0 1.5em;
}
</style>
